import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import moment from "moment";

import DeleteIcon from "@material-ui/icons/Delete";

import { useStyles } from "./MessageBody.css";

class MessageBody extends Component {
  render() {
    const { classes } = this.props;
    const { currentPage, postPerPage } = this.props;
    return (
      <Grid container spacing={2} className={classes.gridRoot}>
        {this.props.messages
          .slice(
            (currentPage - 1) * postPerPage,
            (currentPage - 1) * postPerPage + postPerPage
          )
          .map((message, index) => (
            <Grid item xs={12} sm={12} md={6} xl={4} lg={4} key={index}>
              <Paper
                className={classes.paper}
                onClick={() => this.props.handleClick(message)}
                style={{
                  backgroundColor: `${
                    message.seenByAuthor === false ? "#eee" : "#ffffff"
                  }`,
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flexGrow: 1 }}>
                    From Admin, For <b>{message.bookId.title}</b>
                  </div>
                  <Tooltip arrow title="Delete" className={classes.tooltip}>
                    <DeleteIcon />
                  </Tooltip>
                </div>
                <p style={{ textAlign: "center" }}>{message.message}</p>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  {moment(new Date(message.createdAt)).format("LL")}
                </div>
              </Paper>
            </Grid>
          ))}
      </Grid>
    );
  }
}

export default withStyles(useStyles)(MessageBody);
